import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addPickList,
  deletePickList,
  fetchPickListData,
  updatePickList,
} from "../../apis/pickList";

export const fetchPickListThunk = createAsyncThunk(
  "pickList/fetchPickList",
  async (_, { rejectWithValue }) => {
    try {
      const pickList = await fetchPickListData();
      return pickList.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any;
      return !state.pickList.isDataFetched;
    },
  }
);

export const updatePickListThunk = createAsyncThunk(
  "pickList/updatePickList",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        id: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await updatePickList(id, data);
      if (response && !response.success) {
        return rejectWithValue(response.message);
      }
      return { success: true, data };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletePickListThunk = createAsyncThunk(
  "pickList/deletePickList",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deletePickList(id);
      if (response && !response.success) {
        return rejectWithValue(response.message);
      }
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);

export const addPickListThunk = createAsyncThunk(
  "pickList/addPickList",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addPickList(data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);

// Keep backward compatibility alias
export const fetchPickList = fetchPickListThunk;
